<template lang="pug">
  app-card.file
    app-card-header.file__header
      v-spacer
      span.mr-4 {{ file.date.split(' ')[0] }}
      | {{ file.date.split(' ')[1] }}
    app-card-body.file__body
      app-card-title.file__title(v-html="fileName" v-line-clamp="2")
      app-card-caption.file__tags(v-line-clamp="2") {{ tagsList }}
</template>

<script>
export default {
  name: 'file-store-file',
  props: {
    file: {
      type: Object,
      required: true
    },
    highlightText: String
  },

  computed: {
    tagsList () {
      return this.file.tags.map(t => '# ' + t.name).join(', ')
    },

    fileName () {
      if (!this.highlightText) {
        return this.file.name
      }
      return this.file.name.replace(new RegExp(this.highlightText, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.file {
  &__header {
    padding: 12px 16px 0px;
    height: 32px;
  }

  &__body {
    padding: 12px 16px 8px 12px;
  }

  &__title {
    height: 32px;
    font-family: Roboto Condensed;
    line-height: 16px;
    margin-bottom: 16px;
  }

  &__tags {
    height: 40px;
  }
}
</style>